import { Dropdown } from "react-bootstrap";
import Scrollbar from "../base/Scrollbar";
import { useMemo } from "react";
import LocationTag from "../base/Tags/LocationTag";
import CategoryTag from "../base/Tags/CategoryTag";
import { useTagsStore } from "../../store/tagsStore";
import { useDebouncedProviders } from "../../api/providers/useDebouncedProviders";
// import SubCategoryTag from "../base/Tags/SubCategoryTag";
// import { useNavigate } from "react-router-dom";
// import { ProviderCategories } from "../../data/ecommerce/filterOptions";

const ResultSectionHeader = ({ title }: { title: string }) => {
  return (
    <h6 className="text-1000 fs-9 border-y border-200 py-2 lh-sm mb-0 px-3">
      {title}
    </h6>
  );
};

interface SearchResultProps {
  searchValue?: string;
  onSelectSuggestion: (suggestion: string) => void;
}

const SearchResult = ({
  searchValue = "",
  onSelectSuggestion,
}: SearchResultProps) => {
  // const navigate = useNavigate();
  const providerLocation = useTagsStore((state) => state.providerLocation);
  const ProviderCategories = useTagsStore((state) => state.providerCategories);

  // Extract the last token after the last comma
  const lastCommaIndex = searchValue.lastIndexOf(",");
  const currentInput =
    lastCommaIndex >= 0
      ? searchValue.slice(lastCommaIndex + 1).trim()
      : searchValue.trim();

  // the following functions will filter the search results based on the current input
  const filteredLocations = useMemo(() => {
    const normalize = (str: string) =>
      str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    const searchTerm = normalize(currentInput);
    if (searchTerm.length === 0) return [];

    return providerLocation.filter((location) =>
      normalize(location.name).startsWith(searchTerm)
    );
  }, [currentInput]);

  const filteredCategories = useMemo(() => {
    const normalize = (str: string) =>
      str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    const searchTerm = normalize(currentInput);
    if (searchTerm.length === 0) return [];

    return ProviderCategories.filter((category) =>
      normalize(category.name).startsWith(searchTerm)
    );
  }, [currentInput]);

  // const filteredSubCategories = useMemo(() => {
  //   const searchTerm = currentInput.toLowerCase();
  //   if (searchTerm.length === 0) return [];
  //   return allSubCategories.filter((subCategory) =>
  //     subCategory.toLowerCase().startsWith(searchTerm)
  //   );
  // }, [currentInput]);

  // const filteredProviders = useMemo(() => {
  //   const searchTerm = currentInput.toLowerCase();
  //   if (searchTerm.length === 0) return [];
  //   return allNames.filter(({ name }) =>
  //     name.toLowerCase().startsWith(searchTerm)
  //   );
  // }, [currentInput]);

  const filteredProviders = useDebouncedProviders(currentInput);

  return (
    <Scrollbar autoHeight autoHeightMax={"30rem"}>
      {filteredLocations.length +
        filteredCategories.length +
        filteredProviders.length >
      // filteredProviders.length +
      // filteredSubCategories.length >
      0 ? (
        <>
          <h6 className="text-1000 fs-10 py-2 mb-0 px-3">
            {filteredLocations.length +
              filteredCategories.length +
              // filteredSubCategories.length +
              filteredProviders.length}{" "}
            <span className="text-500">Results</span>
          </h6>
          {/* Categories Section */}
          {filteredCategories.length > 0 && (
            <>
              <ResultSectionHeader title="Categorías de provedoress" />
              <div className="py-2 ">
                {filteredCategories.map((category) => (
                  <Dropdown.Item
                    as="button"
                    key={category.id}
                    onClick={() => onSelectSuggestion(category.name)}
                  >
                    <CategoryTag category={category.name} />
                  </Dropdown.Item>
                ))}
              </div>
            </>
          )}
          {/* SubCategories Section */}
          {/* {filteredSubCategories.length > 0 && (
            <>
              <ResultSectionHeader title="Sub-categorías de servicios y productos" />
              <div className="py-2">
                {filteredSubCategories.map((subCategory) => (
                  <Dropdown.Item
                    as="button"
                    key={subCategory}
                    onClick={() => onSelectSuggestion(subCategory)}
                  >
                    <SubCategoryTag category={subCategory} />
                  </Dropdown.Item>
                ))}
              </div>
            </>
          )} */}

          {/* Proveedores Section */}
          {filteredProviders.length > 0 && (
            <>
              <ResultSectionHeader title="Proveedores" />
              <div className="py-2">
                {filteredProviders.map(({ name, id, uniqueName }) => (
                  <Dropdown.Item
                    as="button"
                    key={id}
                    onClick={() => {
                      window.location.href = `/home/store/${uniqueName}`;
                    }}
                  >
                    {name}
                  </Dropdown.Item>
                ))}
              </div>
            </>
          )}

          {/* Locations Section */}
          {filteredLocations.length > 0 && (
            <>
              <ResultSectionHeader title="Ubicación" />
              <div className="py-2 px-0 m-0 d-flex flex-wrap">
                {filteredLocations.map((location) => (
                  <Dropdown.Item
                    as="button"
                    key={location.id}
                    onClick={() => onSelectSuggestion(location.name)}
                  >
                    <LocationTag city={location.name} />
                  </Dropdown.Item>
                ))}
              </div>
            </>
          )}
        </>
      ) : (
        <div className="py-2 px-3">
          <span className="text-muted">No results found</span>
        </div>
      )}
    </Scrollbar>
  );
};

export default SearchResult;
